export default __webpack_public_path__ + "static/media/kitchen3-after2-1440w.1a4e7a74.png";